import { useEffect } from 'react';

const KUPARTYBUS_BASE =
    process.env.REACT_APP_KUPARTYBUS_URL || 'https://kupartybus.com';
const APP_ID = 'porkysbbq';
const CALLBACK = `${window.location.origin}/auth/sso-callback`;

const SsoStartPage = () => {
    useEffect(() => {
        const state = Math.random().toString(36).slice(2);
        try {
            sessionStorage.setItem('ssoState', state);
        } catch (_) {}
        const params = new URLSearchParams({
            app: APP_ID,
            return_to: CALLBACK,
            state,
        });
        window.location.replace(
            `${KUPARTYBUS_BASE}/external/signin?${params.toString()}`
        );
    }, []);

    return (
        <div style={{ padding: 32, textAlign: 'center' }}>
            <h2>Redirecting you to KU Party Bus sign-in…</h2>
            <p>If nothing happens, <a href={`${KUPARTYBUS_BASE}/login`}>click here</a>.</p>
        </div>
    );
};

export default SsoStartPage;
